import {
  TENANT_STORE_KEY,
  TENANT_STORE_VERSION,
  emptyProductDataBag,
  emptyTenantStore
} from "./chunk-MHD366PF.js";
import {
  EXXAT_STORAGE_PREFIX,
  getStorageItem,
  setStorageItem
} from "./chunk-HA5JJMF5.js";

// src/tenant-products/store.ts
function loadTenantStore() {
  const raw = getStorageItem(TENANT_STORE_KEY);
  if (!raw) return emptyTenantStore();
  try {
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return emptyTenantStore();
    return {
      ...emptyTenantStore(),
      ...parsed,
      v: TENANT_STORE_VERSION,
      catalog: Array.isArray(parsed.catalog) ? parsed.catalog : [],
      products: parsed.products && typeof parsed.products === "object" ? parsed.products : {},
      meta: parsed.meta && typeof parsed.meta === "object" ? parsed.meta : {}
    };
  } catch {
    return emptyTenantStore();
  }
}
function saveTenantStore(store) {
  setStorageItem(TENANT_STORE_KEY, JSON.stringify({ ...store, v: TENANT_STORE_VERSION }));
}
function getActiveCatalog(store) {
  return store.catalog.filter((p) => !p.deletedAt);
}
function getTenantProductById(store, id) {
  return store.catalog.find((p) => p.id === id && !p.deletedAt);
}
function getTenantProductBySlug(store, slug) {
  return store.catalog.find((p) => p.slug === slug && !p.deletedAt);
}
function ensureProductDataBag(store, productId) {
  if (!store.products[productId]) {
    store.products[productId] = emptyProductDataBag();
  }
  return store.products[productId];
}
function catalogToCustomProducts(catalog) {
  return userCatalogToCustomProducts(catalog);
}
function userCatalogToCustomProducts(catalog) {
  return getActiveCatalog({ v: TENANT_STORE_VERSION, catalog, products: {}, meta: {} }).filter((p) => p.source === "user").filter((p) => p.slug !== "prism").map((p) => ({
    suffix: p.brandSuffix,
    brandColor: p.brandColor
  }));
}
function listLegacyStorageKeysForSlug(slug) {
  if (typeof window === "undefined") return [];
  const prefix = `${EXXAT_STORAGE_PREFIX}${slug}:`;
  const out = [];
  try {
    for (let i = 0; i < window.localStorage.length; i++) {
      const key = window.localStorage.key(i);
      if (key?.startsWith(prefix)) out.push(key);
    }
  } catch {
  }
  return out;
}
function legacyKeyToRelativePath(fullKey) {
  return fullKey.startsWith(EXXAT_STORAGE_PREFIX) ? fullKey.slice(EXXAT_STORAGE_PREFIX.length) : fullKey;
}

export {
  loadTenantStore,
  saveTenantStore,
  getActiveCatalog,
  getTenantProductById,
  getTenantProductBySlug,
  ensureProductDataBag,
  catalogToCustomProducts,
  userCatalogToCustomProducts,
  listLegacyStorageKeysForSlug,
  legacyKeyToRelativePath
};
